import React from "react";
import ReactDOM from "react-dom";
import { App } from "./App";
import "./assets/css/antd.less";
import "./index.css";
import { configure } from "./config";
import { LoadingComponent } from "./components/Loading/index";
import zhCN from "antd/es/locale/zh_CN";
import { ConfigProvider } from "antd";
import { initSensors } from "./utils/sensors";

import "./locales"; // 初始化 i18n

const root = document.getElementById("root");

initSensors();

async function bootstrap() {
  ReactDOM.render(<LoadingComponent />, root);

  await configure();

  ReactDOM.render(
    <ConfigProvider locale={zhCN}>
      <App />
    </ConfigProvider>,
    root
  );
}

bootstrap().catch(console.error);
